var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.bills'),"name":"bills","url":_vm.$listRoutes.invoices,"table":_vm.bills,"filters":_vm.billsFilters,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }